
import { Observable, OperatorFunction } from 'rxjs';
import { tap } from 'rxjs/operators';
import { Router } from '@angular/router';

export function goToLoginIfNotLoggedIn<T>(router: Router): OperatorFunction<T, T> {
    return function (source$: Observable<T>): Observable<T> {
        return source$.pipe(tap(
            d => { },
            e => {
                if (!e.error) return;
                console.log(e.error);
                if (!e.error.isLoggedIn) {
                    var currentRoute = router.url;
                    console.log(currentRoute);
                    var encodedUri = encodeURI(currentRoute);
                    router.navigate(['/login'], { queryParams: { target: encodedUri } });
                }
            }
        ));
    };
};
